import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBreakfast = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "breakfast",
	"data-name": "breakfast",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .48,
			x2: 12,
			y2: 2.4
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 22.54,
			y1: 11.02,
			x2: 20.63,
			y2: 11.02
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 3.38,
			y1: 11.02,
			x2: 1.46,
			y2: 11.02
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .48,
			x2: 12,
			y2: 2.4
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 22.54,
			y1: 11.02,
			x2: 20.63,
			y2: 11.02
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 3.38,
			y1: 11.02,
			x2: 1.46,
			y2: 11.02
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.9,
			y1: 4.92,
			x2: 4.55,
			y2: 3.57
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.9,
			y1: 4.92,
			x2: 4.55,
			y2: 3.57
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 19.45,
			y1: 3.57,
			x2: 18.1,
			y2: 4.92
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 19.45,
			y1: 3.57,
			x2: 18.1,
			y2: 4.92
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: .5,
			y1: 14.85,
			x2: 23.5,
			y2: 14.85
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.42,
			y1: 18.69,
			x2: 21.58,
			y2: 18.69
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.29,
			y1: 22.52,
			x2: 18.71,
			y2: 22.52
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M16.27,14.85A5.66,5.66,0,0,0,17.75,11a5.75,5.75,0,0,0-11.5,0,5.66,5.66,0,0,0,1.48,3.83"
		})
	]
});
const ForwardRef = forwardRef(SvgBreakfast);
export default ForwardRef;
